module.exports = __webpack_public_path__ + "static/media/22.1.856233d8.jpg";